module.exports = __webpack_public_path__ + "static/media/robot-painting.a4d7ef7f.jpg";